var mapElement = document.getElementById('the-map');

if (mapElement) {
    setTimeout(drawMap, 2000);
    window.addEventListener('resize', function(event){
        setTimeout(drawMap, 2000);
    });
}

function drawMapFinish() {
    mapElement.classList.remove('loading');
}

function drawMap() {
    // destroy the previous map to fit the container size and redraw it
    mapElement.innerHTML = '';

    $(".states-dropdown select").on('change', function() {
        var form = $(".states-dropdown form");
        if(this.value === 'ny-metro' || this.value === 'New York'){
            form.attr("action",form.data('action-ny'));
        } else {
            form.attr("action", form.data('action-init'));
        }
    });

    var isHome = $('body').hasClass('home');
    var isHomeNew = $('body').hasClass('page-template-page-homepage-new');
    var theHeight = $(mapElement).height() + 70;
    var map = new Datamap({
        element: mapElement,
        scope: 'usa',
        height: theHeight, // If not null, datamaps will grab the height of 'element'
        // width: null, // If not null, datamaps will grab the width of 'element',
        // responsive: false, // If true, call `resize()` on the map object when it should adjust it's size

        fills: {
            defaultFill: '#ddd', // The keys in this object map to the "fillKey" of [data] or [bubbles]
            // lightBlue: '#2c6aa5',
            // white: '#000'
            // },
            // bubblesConfig: {
            bubblesFill: '#386bac',
            FillColor: '#386bac',
            borderWidth: 0.7,
            borderOpacity: 0.7,
            borderColor: '#fff',
            fillOpacity: 1,
            animate: true,
            highlightFillColor: '#FC8D59',
            highlightBorderColor: '#fff',
            highlightBorderWidth: 0,

    
        },
        
        dataType: 'json', // For use with dataUrl, currently 'json' or 'csv'. CSV should have an `id` column
        dataUrl: null, // If not null, datamaps will attempt to fetch this based on dataType ( default: json )
        geographyConfig: {
            dataUrl: null, // If not null, datamaps will fetch the map JSON (currently only supports topojson)
            hideAntarctica: true,
            hideHawaiiAndAlaska : false,
            borderWidth: 1,
            borderOpacity: 1,
            borderColor: '#353132',
            popupTemplate: function(geography, data) { // This function should just return a string
                return  '<div class="hoverinfo">' + geography.properties.name + '<br> Total Active Neutrals:' +  data.theNumber + '</div>';
            },
            popupOnHover: true, // True to show the popup while hovering
            popupOnHover: true, // True to show the popup while hovering
            highlightOnHover: true,
            highlightFillColor: '#386bac',
            highlightBorderColor: '#062345',
            highlightBorderWidth: 2,
            highlightBorderOpacity: 1

        },
        data:{
            "AZ": {
                "theNumber": 5
            },
            "CO": {
                "theNumber": 34
            },
            "DE": {
                "theNumber": 8
            },
            "FL": {
                "theNumber": 141
            },
            "GA": {
                "theNumber": 57
            },
            "HI": {
                "theNumber": 14
            },
            "ID": {
                "theNumber": 5
            },
            "IL": {
                "theNumber": 56
            },
            "IN": {
                "theNumber": 35
            },
            "IA": {
                "theNumber": 15
            },
            "KS": {
                "theNumber": 18
            },
            "KY": {
                "theNumber": 35
            },
            "LA": {
                "theNumber": 37
            },
            "MD": {
                "theNumber": 40
            },
            "ME": {
                "theNumber": 11
            },
            "MA": {
                "theNumber": 65
            },
            "MN": {
                "theNumber": 14
            },
            "MI": {
                "theNumber": 36
            },
            "MS": {
                "theNumber": 9
            },
            "MO": {
                "theNumber": 28
            },
            "MT": {
                "theNumber": 17
            },
            "NC": {
                "theNumber": 45
            },
            "NE": {
                "theNumber": 14
            },
            "NV": {
                "theNumber": 29
            },
            "NH": {
                "theNumber": 18
            },
            "NJ": {
                "theNumber": 66
            },
            "NY": {
                "theNumber": 115
            },
            "ND": {
                "theNumber": 5
            },
            "NM": {
                "theNumber": 17
            },
            "OH": {
                "theNumber": 89
            },
            "OK": {
                "theNumber": 31
            },
            "OR": {
                "theNumber": 18
            },
            "PA": {
                "theNumber": 94
            },
            "RI": {
                "theNumber": 10
            },
            "SC": {
                "theNumber": 29
            },
            "SD": {
                "theNumber": 4
            },
            "TN": {
                "theNumber": 64
            },
            "TX": {
                "theNumber": 129
            },
            "UT": {
                "theNumber": 29
            },
            "WI": {
                "theNumber": 32
            },
            "VA": {
                "theNumber": 55
            },
            "VT": {
                "theNumber": 17
            },
            "WA": {
                "theNumber": 35
            },
            "WV": {
                "theNumber": 3
            },
            "WY": {
                "theNumber": 4
            },
            "CA": {
                "theNumber": 127
            },
            "CT": {
                "theNumber": 51
            },
            "AK": {
                "theNumber": 9
            },
            "AR": {
                "theNumber": 39
            },
            "AL": {
                "theNumber": 57
            }
        },
        done: function() {

        }
    });


    map.svg.selectAll('.datamaps-subunit, .neutrals .datamaps-subunit').on('click', function(geography) {
        if(geography.id == 'NY'){
            window.location = mapElement.getAttribute('data-action-ny') +  '?state='+geography.properties.name; 
        } else {
            window.location = mapElement.getAttribute('data-action-init') +  '?state='+geography.properties.name;
        }
    });

    var bublesData = [

        // Washington
        /*{ latitude: 47.042418, longitude: -122.893077, radius:6 },*/
        { latitude: 47.685279, longitude: -118.031914, radius:4 },
        { latitude: 46.394977, longitude: -118.631914, radius:4 },
        { latitude: 48.012818, longitude: -121.456595, radius:4 },

        // // Oregon
        { latitude: 47.685279, longitude: -118.031914, radius:4 },
        { latitude: 46.394977, longitude: -118.631914, radius:4 },
        { latitude: 48.012818, longitude: -121.456595, radius:4 },
        { latitude: 44.776001, longitude: -122.668933, radius:4 },
        { latitude: 45.368453, longitude: -121.293084, radius:4 },
        { latitude: 45.165641, longitude: -118.594339, radius:4 },
        { latitude: 44.981683, longitude: -117.555334, radius:4 },
        /*{ latitude: 44.931109, longitude: -123.029159, radius:6 },*/
        { latitude: 42.382402, longitude: -122.942108, radius:4 },
        { latitude: 42.060418, longitude: -120.588969, radius:4 },
        { latitude: 42.643044, longitude: -117.060143, radius:4 },
        { latitude: 42.974070, longitude: -118.596245, radius:4 },
        { latitude: 44.002431, longitude: -118.126039, radius:4 },

        // // Idaho
        { latitude: 43.586429, longitude: -116.725627, radius:4 },
        { latitude: 43.157413, longitude: -116.112047, radius:4 },
        { latitude: 42.363439, longitude: -112.380781, radius:4 },
        { latitude: 43.217839, longitude: -113.591118, radius:4 },
        { latitude: 43.740704, longitude: -111.272183, radius:4 },
        { latitude: 45.690770, longitude: -115.059955, radius:4 },
        { latitude: 46.436144, longitude: -114.591292, radius:4 },
        /*{ latitude: 43.613739, longitude: -116.237651, radius:6 },*/

        // // CA
        { latitude: 40.869442, longitude: -121.502041, radius:4 },
        { latitude: 41.235067, longitude: -120.445339, radius:4 },
        { latitude: 40.721716, longitude: -120.035093, radius:4 },
        { latitude: 39.169319, longitude: -120.038594, radius:4 },
        { latitude: 38.217369, longitude: -121.455053, radius:4 },
        { latitude: 36.076992, longitude: -120.563402, radius:4 },
        { latitude: 35.779729, longitude: -118.026456, radius:4 },
        { latitude: 36.379262, longitude: -117.482328, radius:4 },
        { latitude: 34.654970, longitude: -117.757542, radius:4 },
        { latitude: 34.492489, longitude: -117.041620, radius:4 },
        { latitude: 34.241836, longitude: -116.101833, radius:4 },
        /*{ latitude: 35.349399, longitude: -119.160989, radius:6 },*/

        // NV
        { latitude: 36.481745, longitude: -114.857087, radius:4 },
        { latitude: 36.890406, longitude: -115.154615, radius:4 },
        { latitude: 37.154335, longitude: -115.583027, radius:4 },
        { latitude: 38.042979, longitude: -114.027283, radius:4 },
        { latitude: 38.559979, longitude: -116.353783, radius:4 },
        { latitude: 39.712217, longitude: -115.273585, radius:4 },
        { latitude: 40.155726, longitude: -115.334052, radius:4 },
        { latitude: 40.724801, longitude: -115.086029, radius:4 },
        { latitude: 41.544434, longitude: -114.179797, radius:4 },
        { latitude: 39.784135, longitude: -117.231881, radius:4 },
        { latitude: 41.034325, longitude: -117.709320, radius:4 },
        /*{ latitude: 39.923249, longitude: -118.394835, radius:6 },*/

        // AZ
        { latitude: 32.051040, longitude: -109.612235, radius:4 },
        { latitude: 32.892453, longitude: -111.238514, radius:4 },
        { latitude: 32.775426, longitude: -113.546051, radius:4 },
        { latitude: 33.250950, longitude: -111.685208, radius:4 },
        { latitude: 34.107920, longitude: -113.574094, radius:4 },
        { latitude: 34.823748, longitude: -112.332097, radius:4 },
        { latitude: 35.347224, longitude: -112.421536, radius:4 },
        { latitude: 35.056895, longitude: -111.815040, radius:4 },
        { latitude: 34.867170, longitude: -110.681100, radius:4 },
        { latitude: 35.359785, longitude: -109.553291, radius:4 },
        /*{ latitude: 33.585038, longitude: -110.350461, radius:6 },*/

        // MT
        { latitude: 45.795514, longitude: -113.087973, radius:4 },
        { latitude: 45.060301, longitude: -111.589372, radius:4 },
        { latitude: 45.546473, longitude: -111.266578, radius:4 },
        { latitude: 46.388635, longitude: -111.775945, radius:4 },
        { latitude: 48.076086, longitude: -114.506563, radius:4 },
        /*{ latitude: 48.220708, longitude: -112.211902, radius:6 },*/
        { latitude: 45.804827, longitude: -109.842354, radius:4 },
        { latitude: 46.015242, longitude: -108.976119, radius:4 },
        { latitude: 46.496252, longitude: -108.158503, radius:4 },
        { latitude: 48.389141, longitude: -107.438227, radius:4 },
        { latitude: 47.850935, longitude: -104.561960, radius:4 },
        { latitude: 46.608508, longitude: -104.528894, radius:4 },
        { latitude: 46.172154, longitude: -105.394271, radius:4 },
        { latitude: 45.159912, longitude: -105.888155, radius:4 },
        { latitude: 45.346341, longitude: -104.513820, radius:4 },

        // // WY
        { latitude: 41.739215, longitude: -110.572035, radius:4 },
        { latitude: 42.000307, longitude: -110.057562, radius:4 },
        { latitude: 42.052155, longitude: -109.239437, radius:4 },
        /*{ latitude: 43.876202, longitude: -109.732127, radius:6 },*/
        { latitude: 44.793783, longitude: -108.663612, radius:4 },
        { latitude: 44.019747, longitude: -106.847568, radius:4 },
        { latitude: 43.248516, longitude: -107.297673, radius:4 },
        { latitude: 43.418164, longitude: -105.928472, radius:4 },
        { latitude: 43.261767, longitude: -104.672948, radius:4 },
        { latitude: 43.615535, longitude: -104.171206, radius:4 },


        // CO
        { latitude: 40.060096, longitude: -108.062930, radius:4 },
        { latitude: 40.112845, longitude: -106.384390, radius:4 },
        { latitude: 40.625413, longitude: -104.353983, radius:4 },
        /*{ latitude: 39.445047, longitude: -103.905400, radius:6 },*/
        { latitude: 38.960569, longitude: -104.665458, radius:4 },
        { latitude: 38.861409, longitude: -106.002664, radius:4 },
        { latitude: 38.248545, longitude: -105.477631, radius:4 },
        { latitude: 38.210933, longitude: -107.084286, radius:4 },
        { latitude: 37.628755, longitude: -106.969015, radius:4 },
        { latitude: 37.071419, longitude: -106.192798, radius:4 },
        { latitude: 37.066731, longitude: -103.862117, radius:4 },
        { latitude: 37.503125, longitude: -102.728760, radius:4 },
        { latitude: 37.503125, longitude: -102.728760, radius:4 },
        { latitude: 37.057807, longitude: -102.212865, radius:4 },

        // // UT
        { latitude: 41.477586, longitude: -112.428955, radius:4 },
        /*{ latitude: 40.229215, longitude: -112.666482, radius:6 },*/
        { latitude: 39.788220, longitude: -112.567904, radius:4 },
        { latitude: 39.201020, longitude: -113.025229, radius:4 },
        { latitude: 37.869702, longitude: -112.916145, radius:4 },
        { latitude: 37.254190, longitude: -110.765021, radius:4 },
        { latitude: 38.916020, longitude: -110.701839, radius:4 },
        { latitude: 39.218619, longitude: -109.500921, radius:4 },

        // // NM
        { latitude: 36.235150, longitude: -107.619432, radius:4 },
        { latitude: 36.706271, longitude: -107.327714, radius:4 },
        { latitude: 36.859471, longitude: -104.996767, radius:4 },
        { latitude: 34.867846, longitude: -107.125103, radius:4 },
        { latitude: 35.159840, longitude: -105.955850, radius:4 },
        { latitude: 35.288773, longitude: -103.639717, radius:4 },
        { latitude: 33.267115, longitude: -108.446059, radius:4 },
        { latitude: 33.474142, longitude: -103.509724, radius:4 },
        { latitude: 32.856159, longitude: -104.568827, radius:4 },
        /*{ latitude: 33.450692, longitude: -107.075384, radius:6 },*/

        // // TX
        { latitude: 35.129900, longitude: -101.401510, radius:4 },
        { latitude: 32.652604, longitude: -102.088677, radius:4 },
        { latitude: 33.235129, longitude: -100.538011, radius:4 },
        { latitude: 32.751759, longitude: -100.920674, radius:4 },
        /*{ latitude: 31.744574, longitude: -101.384746, radius:6 },*/
        { latitude: 30.876418, longitude: -102.416883, radius:4 },
        { latitude: 31.953193, longitude: -97.558589, radius:4 },
        { latitude: 31.990130, longitude: -95.734016, radius:4 },
        { latitude: 30.128051, longitude: -99.054171, radius:4 },
        { latitude: 30.056030, longitude: -96.906024, radius:4 },
        { latitude: 28.260377, longitude: -99.114216, radius:4 },
        { latitude: 32.010171, longitude: -95.732846, radius:4 },
        { latitude: 30.602855, longitude: -94.719696, radius:4 },

        // // LA
        { latitude: 32.443680, longitude: -93.845865, radius:4 },
        { latitude: 30.746227, longitude: -92.999432, radius:4 },

        // // OK
        { latitude: 36.614636, longitude: -98.656545, radius:4 },
        { latitude: 36.436686, longitude: -98.175673, radius:4 },
        { latitude: 35.825775, longitude: -99.042115, radius:4 },
        { latitude: 36.367233, longitude: -95.893438, radius:4 },
        { latitude: 35.691057, longitude: -95.857386, radius:4 },
        { latitude: 33.825119, longitude: -96.061847, radius:4 },
        { latitude: 33.991051, longitude: -95.613787, radius:4 },
        /*{ latitude: 34.827145, longitude: -98.873626, radius:6 },*/

        // // AR
        { latitude: 35.818636, longitude: -94.039417, radius:4 },
        { latitude: 35.623590, longitude: -93.547511, radius:4 },
        { latitude: 36.166028, longitude: -91.077695, radius:4 },
        { latitude: 33.859987, longitude: -93.416080, radius:4 },
        /*{ latitude: 34.189552, longitude: -92.984011, radius:6 },*/
        { latitude: 34.356408, longitude: -90.999214, radius:4 },

        // // KS
        { latitude: 37.920842, longitude: -101.237407, radius:4 },
        /*{ latitude: 37.767960, longitude: -100.009610, radius:6 },*/
        { latitude: 38.504737, longitude: -99.144647, radius:4 },
        { latitude: 37.826016, longitude: -98.174557, radius:4 },
        { latitude: 37.318449, longitude: -97.003410, radius:4 },
        { latitude: 38.471827, longitude: -96.573839, radius:4 },
        { latitude: 39.250978, longitude: -97.710617, radius:4 },
        { latitude: 39.131986, longitude: -97.297218, radius:4 },
        { latitude: 39.150688, longitude: -101.402487, radius:4 },

        // //ND
        { latitude: 48.106115, longitude: -100.756529, radius:4 },
        { latitude: 46.154870, longitude: -97.995217, radius:4 },
        { latitude: 48.039814, longitude: -100.755511, radius:4 },
        /*{ latitude: 47.229655, longitude: -99.278241, radius:6 },*/

        // //SD
        { latitude: 45.478049, longitude: -99.779201, radius:4 },
        { latitude: 44.861225, longitude: -101.706160, radius:4 },
        { latitude: 43.595039, longitude: -103.400172, radius:4 },
        { latitude: 43.591679, longitude: -101.594851, radius:4 },
        { latitude: 44.814989, longitude: -98.029151, radius:4 },
        /*{ latitude: 44.365298, longitude: -99.042006, radius:6 },*/
        { latitude: 43.523251, longitude: -97.205754, radius:4 },
        { latitude: 43.023969, longitude: -97.677041, radius:4 },

        // //NR
        { latitude: 41.657661, longitude: -103.358333, radius:4 },
        { latitude: 42.111613, longitude: -101.263310, radius:4 },
        { latitude: 41.704146, longitude: -100.770313, radius:4 },
        /*{ latitude: 41.232619, longitude: -100.802106, radius:6 },*/
        { latitude: 41.686540, longitude: -99.042506, radius:4 },
        { latitude: 40.984022, longitude: -98.242525, radius:4 },
        { latitude: 40.949174, longitude: -96.570841, radius:4 },

        // // MN
        { latitude: 47.332831, longitude: -95.046528, radius:4 },
        { latitude: 45.467679, longitude: -94.782072, radius:4 },
        /*{ latitude: 44.752359, longitude: -95.162242, radius:6 },*/
        { latitude: 46.471132, longitude: -92.276937, radius:4 },

        // // IA
        { latitude: 42.142884, longitude: -94.628798, radius:4 },
        { latitude: 42.088714, longitude: -92.511005, radius:4 },
        { latitude: 41.898641, longitude: -92.011629, radius:4 },
        { latitude: 42.167510, longitude: -94.684321, radius:4 },
        /*{ latitude: 41.590939, longitude: -93.620866, radius:6 },*/
        { latitude: 40.817363, longitude: -93.107779, radius:4 },

        // // MO
        { latitude: 40.280255, longitude: -94.417414, radius:4 },
        { latitude: 40.159130, longitude: -91.882878, radius:4 },
        { latitude: 37.709703, longitude: -94.250887, radius:4 },
        { latitude: 38.083236, longitude: -92.536450, radius:4 },
        { latitude: 38.880930, longitude: -90.228747, radius:4 },
        { latitude: 37.629797, longitude: -92.342340, radius:4 },
        /*{ latitude: 37.720165, longitude: -91.667979, radius:6 },*/

        // // MI
        { latitude: 46.209685, longitude: -88.565941, radius:4 },
        /*{ latitude: 44.141473, longitude: -85.478254, radius:6 },*/

        // // IL
        { latitude: 41.722261, longitude: -88.202288, radius:4 },
        { latitude: 39.333712, longitude: -88.194644, radius:4 },
        { latitude: 38.534429, longitude: -88.852508, radius:4 },
        /*{ latitude: 41.380028, longitude: -89.455565, radius:6 },*/

        // // IL
        { latitude: 45.174391, longitude: -92.453479, radius:4 },
        { latitude: 44.647069, longitude: -92.042846, radius:4 },
        { latitude: 44.253725, longitude: -88.577264, radius:4 },
        { latitude: 43.479453, longitude: -88.282536, radius:4 },
        /*{ latitude: 45.786928, longitude: -91.293200, radius:6 },*/

        // IN
        /*{ latitude: 41.062561, longitude: -86.419493, radius:6 },*/
        { latitude: 41.475257, longitude: -85.089307, radius:4 },

        // KY
        { latitude: 37.902023, longitude: -83.198016, radius:4 },
        /*{ latitude: 37.163281, longitude: -86.481958, radius:6 },*/

        // MS
        { latitude: 34.752666, longitude: -89.323886, radius:4 },
        { latitude: 33.672233, longitude: -88.471063, radius:4 },
        { latitude: 33.121822, longitude: -88.989160, radius:4 },
        /*{ latitude: 33.919656, longitude: -88.752712, radius:6 },*/

        // AL
        { latitude: 33.818503, longitude: -87.239261, radius:4 },
        { latitude: 33.862193, longitude: -85.576183, radius:4 },
        { latitude: 32.565610, longitude: -87.473097, radius:4 },
        { latitude: 31.941792, longitude: -85.638991, radius:4 },
        /*{ latitude: 32.007691, longitude: -87.624465, radius:6 },*/

        // GA
        { latitude: 33.434367, longitude: -84.045604, radius:4 },
        { latitude: 33.678778, longitude: -83.687682, radius:4 },
        /*{ latitude: 31.630787, longitude: -84.083768, radius:6 },*/
        { latitude: 32.074391, longitude: -81.549440, radius:4 },
        { latitude: 30.700212, longitude: -83.688697, radius:4 },

        // // FL
        { latitude: 29.927996, longitude: -85.506049, radius:4 },
        { latitude: 30.206834, longitude: -83.226451, radius:4 },
        { latitude: 28.123343, longitude: -81.422393, radius:4 },
        { latitude: 26.755252, longitude: -80.833934, radius:4 },
        /*{ latitude: 29.701865, longitude: -82.204042, radius:6 },*/

        // SC
        { latitude: 34.764644, longitude: -82.238249, radius:4 },
        { latitude: 34.505826, longitude: -80.444383, radius:4 },
        /*{ latitude: 33.534669, longitude: -80.293065, radius:6 },*/

        // // TN
        { latitude: 35.514572, longitude: -88.848821, radius:4 },
        { latitude: 36.055098, longitude: -87.518487, radius:4 },
        /*{ latitude: 36.040071, longitude: -85.973131, radius:6 },*/
        { latitude: 36.441976, longitude: -85.571222, radius:4 },
        { latitude: 35.211348, longitude: -85.409915, radius:4 },
        { latitude: 36.182493, longitude: -83.241000, radius:4 },

        // ME
        /*{ latitude: 45.189801, longitude: -68.934580, radius:6 },*/
        { latitude: 43.952272, longitude: -70.684441, radius:4 },

        // NH
        { latitude: 42.993190, longitude: -72.240270, radius:4 },

        // // NY
        { latitude: 42.817768, longitude: -77.769025, radius:4 },
        { latitude: 44.140225, longitude: -74.542763, radius:4 },
        /*{ latitude: 42.713002, longitude: -76.336007, radius:6 },*/
        /*{ latitude: 40.594320, longitude: -74.414495, radius:6 },*/
        { latitude: 42.988198, longitude: -74.973815, radius:4 },
        { latitude: 41.625894, longitude: -74.761961, radius:4 },

        { latitude: 43.1854445, longitude: -77.6865426, radius:4 }, // Rochester
        { latitude: 42.6681345, longitude: -73.8465049, radius:4 },	// Albany
        { latitude: 41.1210672, longitude: -74.0125289, radius:4 },	// Westchester
        { latitude: 40.6485493, longitude: -74.0079057, radius:6 }, // NYC
        // NJ
        /*{ latitude: 40.542411, longitude: -74.455161, radius:6 },*/

        // // PA
        { latitude: 40.347562, longitude: -75.134701, radius:4 },
        { latitude: 41.468288, longitude: -77.351247, radius:4 },
        /*{ latitude: 41.175334, longitude: -79.383913, radius:6 },*/
        { latitude: 40.042434, longitude: -79.581102, radius:4 },

        // // OH
        { latitude: 40.826779, longitude: -84.145893, radius:4 },
        { latitude: 40.568261, longitude: -82.894078, radius:4 },
        { latitude: 39.307358, longitude: -83.239023, radius:4 },
        { latitude: 39.741986, longitude: -81.913728, radius:4 },

        // // WV
        { latitude: 38.499073, longitude: -82.258332, radius:4 },
        /*{ latitude: 39.073963, longitude: -80.469986, radius:6 },*/
        { latitude: 39.139224, longitude: -78.895420, radius:4 },

        // // WV
        { latitude: 38.277944, longitude: -79.671347, radius:4 },
        { latitude: 36.583720, longitude: -78.663637, radius:4 },
        /*{ latitude: 37.208567, longitude: -77.506057, radius:6 },*/

        // NC
        { latitude: 34.965274, longitude: -77.883698, radius:4 },
        /*{ latitude: 35.706555, longitude: -77.639685, radius:6 },*/

        // Alska
        { latitude: 61.2176, longitude: -149.8997, radius:6 },
        { latitude: 58.3005, longitude: -134.4201, radius:4 },


        // Hawai
        { latitude: 21.3099, longitude: -157.8581, radius:4 },
        { latitude: 20.7984, longitude: -156.3319, radius:4 },
        
        {
            radius: 6,
            name: "Alabama",
            capital: "Montgomery",
            latitude: "32.361538",
            longitude: "-86.279118",
        },
        {
            radius: 6,
            name: "Arizona",
            capital: "Phoenix",
            latitude: "33.448457",
            longitude: "-112.073844"
        },
        {
            radius: 6,
            name: "Arkansas",
            capital: "Little Rock",
            latitude: "34.736009",
            longitude: "-92.331122",
        },
        {
            radius: 6,
            name: "California",
            capital: "Sacramento",
            latitude: "38.555605",
            longitude: "-121.468926"
        },
        {
            radius: 6,
            name: "Colorado",
            capital: "Denver",
            latitude: "39.7391667",
            longitude: "-104.984167"
        },
        {
            radius: 6,
            name: "Connecticut",
            capital: "Hartford",
            latitude: "41.767",
            longitude: "-72.677"
            ,  },
        {
            radius: 6,
            name: "Delaware",
            capital: "Dover",
            latitude: "39.161921",
            longitude: "-75.526755",
        },
        {
            radius: 6,
            name: "Florida",
            capital: "Tallahassee",
            latitude: "30.4518",
            longitude: "-84.27277"
            ,		  },
        {
            radius: 6,
            name: "Georgia",
            capital: "Atlanta",
            latitude: "33.76",
            longitude: "-84.39"
            , },
        {
            radius: 6,
            name: "Idaho",
            capital: "Boise",
            latitude: "43.613739",
            longitude: "-116.237651"
        },
        {
            radius: 6,
            name: "Illinois",
            capital: "Springfield",
            latitude: "39.783250",
            longitude: "-89.650373",
        },
        {
            radius: 6,
            name: "Indiana",
            capital: "Indianapolis",
            latitude: "39.790942",
            longitude: "-86.147685",
        },
        {
            radius: 6,
            name: "Iowa",
            capital: "Des Moines",
            latitude: "41.590939",
            longitude: "-93.620866",
        },
        {
            radius: 6,
            name: "Kansas",
            capital: "Topeka",
            latitude: "39.04",
            longitude: "-95.69"
            , },
        {
            radius: 6,
            name: "Kentucky",
            capital: "Frankfort",
            latitude: "38.197274",
            longitude: "-84.86311"
            ,		  },
        {
            radius: 6,
            name: "Louisiana",
            capital: "Baton Rouge",
            latitude: "30.45809",
            longitude: "-91.140229",
        },
        {
            radius: 6,
            name: "Maine",
            capital: "Augusta",
            latitude: "44.323535",
            longitude: "-69.765261",
        },
        {
            radius: 6,
            name: "Maryland",
            capital: "Annapolis",
            latitude: "38.972945",
            longitude: "-76.501157",
        },
        {
            radius: 6,
            name: "Massachusetts",
            capital: "Boston",
            latitude: "42.2352",
            longitude: "-71.0275"
            ,	  },
        {
            radius: 6,
            name: "Michigan",
            capital: "Lansing",
            latitude: "42.7335",
            longitude: "-84.5467"
            ,	  },
        {
            radius: 6,
            name: "Minnesota",
            capital: "Saint Paul",
            latitude: "44.95",
            longitude: "-93.094"
            ,  },
        {
            radius: 6,
            name: "Mississippi",
            capital: "Jackson",
            latitude: "32.320",
            longitude: "-90.207"
            ,  },
        {
            radius: 6,
            name: "Missouri",
            capital: "Jefferson City",
            latitude: "38.572954",
            longitude: "-92.189283",
        },
        {
            radius: 6,
            name: "Montana",
            capital: "Helana",
            latitude: "46.595805",
            longitude: "-112.027031"
        },
        {
            radius: 6,
            name: "Nebraska",
            capital: "Lincoln",
            latitude: "40.809868",
            longitude: "-96.675345",
        },
        {
            radius: 6,
            name: "Nevada",
            capital: "Carson City",
            latitude: "39.160949",
            longitude: "-119.753877"
        },
        {
            radius: 6,
            name: "New Hampshire",
            capital: "Concord",
            latitude: "43.220093",
            longitude: "-71.549127",
        },
        {
            radius: 6,
            name: "New Jersey",
            capital: "Trenton",
            latitude: "40.221741",
            longitude: "-74.756138",
        },
        {
            radius: 6,
            name: "New Mexico",
            capital: "Santa Fe",
            latitude: "35.667231",
            longitude: "-105.964575"
        },
        {
            radius: 6,
            name: "New York",
            capital: "Albany",
            latitude: "42.659829",
            longitude: "-73.781339",
        },
        {
            radius: 6,
            name: "North Carolina",
            capital: "Raleigh",
            latitude: "35.771",
            longitude: "-78.638"
            ,  },
        {
            radius: 6,
            name: "North Dakota",
            capital: "Bismarck",
            latitude: "46.800712",
            longitude: "-100.789029"
        },
        {
            radius: 6,
            name: "Ohio",
            capital: "Columbus",
            latitude: "39.962245",
            longitude: "-83.000647",
        },
        {
            radius: 6,
            name: "Oklahoma",
            capital: "Oklahoma City",
            latitude: "35.482309",
            longitude: "-97.534994",
        },
        {
            radius: 6,
            name: "Oregon",
            capital: "Salem",
            latitude: "44.931109",
            longitude: "-123.029159"
        },
        {
            radius: 6,
            name: "Pennsylvania",
            capital: "Harrisburg",
            latitude: "40.269789",
            longitude: "-76.875613",
        },
        {
            radius: 6,
            name: "Rhode Island",
            capital: "Providence",
            latitude: "41.82355",
            longitude: "-71.422132",
        },
        {
            radius: 6,
            name: "South Carolina",
            capital: "Columbia",
            latitude: "34.000",
            longitude: "-81.035"
            ,  },
        {
            radius: 6,
            name: "South Dakota",
            capital: "Pierre",
            latitude: "44.367966",
            longitude: "-100.336378"
        },
        {
            radius: 6,
            name: "Tennessee",
            capital: "Nashville",
            latitude: "36.165",
            longitude: "-86.784"
            ,  },
        {
            radius: 6,
            name: "Texas",
            capital: "Austin",
            latitude: "30.266667",
            longitude: "-97.75"
            , },
        {
            radius: 6,
            name: "Utah",
            capital: "Salt Lake City",
            latitude: "40.7547",
            longitude: "-111.892622"
        },
        {
            radius: 6,
            name: "Vermont",
            capital: "Montpelier",
            latitude: "44.26639",
            longitude: "-72.57194"
            ,		  },
        {
            radius: 6,
            name: "Virginia",
            capital: "Richmond",
            latitude: "37.54",
            longitude: "-77.46"
            , },
        {
            radius: 6,
            name: "Washington",
            capital: "Olympia",
            latitude: "47.042418",
            longitude: "-122.893077"
        },
        {
            radius: 6,
            name: "West Virginia",
            capital: "Charleston",
            latitude: "38.349497",
            longitude: "-81.633294",
        },
        {
            radius: 6,
            name: "Wisconsin",
            capital: "Madison",
            latitude: "43.074722",
            longitude: "-89.384444",
        },
        {
            radius: 6,
            name: "Wyoming",
            capital: "Cheyenne",
            latitude: "41.145548",
            longitude: "-104.802042"
        }

    ];

    var bublesArray = [];

    $.each(bublesData, function( index, value ) {

        firstElement = {'latitude':value.latitude, 'longitude':value.longitude, 'radius': value.radius, fillKey: 'bubblesFill', strokeWidth: 0.5 };
        secondElement = {'latitude':value.latitude, 'longitude':value.longitude, 'radius': value.radius, fillKey: 'bubblesFill', strokeWidth: 0.5 };


        if(value.radius > 5){
            secondElement.radius = 4;
        } else {
            secondElement.radius = 3;
        }

        bublesArray.push(firstElement);
        bublesArray.push(secondElement);
    });

    map.bubbles(bublesArray);

    var smallStateLabelColor = '#000';
    if (isHome || isHomeNew) {
        smallStateLabelColor = '#fff';
    }

    map.labels({smallStateLabelColor: smallStateLabelColor});

    drawMapFinish();
}